import React from 'react'
import { Image } from 'antd';
import cosmosIcon from '@iso/assets/images/login_icon.svg';

import DefaultIconWrapper from './DefaultIcon.styles';

export default function DefaultIcon(props) {
  const loading = props.loading
  return (
    <DefaultIconWrapper className='default-icon'>
        <div className='default-icon--image-default' style={{ backgroundColor: `${loading ? 'transparent' :'#0F8495'}` }}>
          <Image src={cosmosIcon} preview={false}/>
        </div>
    </DefaultIconWrapper>
  )
}
